import { Lock, TriangleAlert } from 'lucide-react';
import type { ReactNode } from 'react';
import { cx } from './cx.ts';
import s from './DataTag.module.css';
import m from './Motifs.module.css';
import t from './type.module.css';

export type DataTagTone = 'standard' | 'signal' | 'hazard' | 'mine';

/**
 * C-02 Data tag: `CONF │ X7K2QP`, the datasheet pair (docs/design/components/C-02-data-tag.md).
 * `spoken` is the expanded label for screen readers ("Confirmation code"), voice.md dictionary.
 */
export function DataTag({
  label,
  value,
  tone = 'standard',
  readout = true,
  spoken,
}: {
  label: string;
  value?: string;
  tone?: DataTagTone;
  /** Codes and numbers use the readout face; words use the text face. */
  readout?: boolean;
  spoken?: string;
}) {
  return (
    <span className={cx(s.tag, s[tone])}>
      <span className={t.srOnly}>{[spoken ?? label, value].filter(Boolean).join(', ')}</span>
      <span className={cx(s.label, t.label)} aria-hidden="true">
        {tone === 'hazard' && <span className={cx(s.stripes, m.hazard)} />}
        {tone === 'mine' && <Lock className={s.icon} strokeWidth={2.5} />}
        {tone === 'hazard' && <TriangleAlert className={s.icon} strokeWidth={2.5} />}
        {label}
      </span>
      {value && (
        <span className={cx(s.value, readout ? t.readoutS : t.bodyS)} aria-hidden="true">
          {value}
        </span>
      )}
    </span>
  );
}

/** Tags wrap with 4pt gaps. */
export function TagGroup({ children }: { children: ReactNode }) {
  return <span className={s.group}>{children}</span>;
}
